import { render, staticRenderFns } from "./DaysPage.vue?vue&type=template&id=046cb507&scoped=true"
import script from "./DaysPage.vue?vue&type=script&lang=js"
export * from "./DaysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046cb507",
  null
  
)

export default component.exports